

//引入
import request from "../utils/request";
const api = {

    //详情
    listinfo: function (params) {

        return request({

            method: "get",
            params,
            url: `middlescreen/api/zhwybzhjs/listinfo`,
            params
        });
    },
    //多元评价详情
    pjjdinfo: function (params) {
        return request({
            method: "get",
            params,
            url: `middlescreen/api/zhwybzhjs/pjjdinfo`,
            params
        });
    },

    //投票详情
    qtgsinfo: function (params) {
        return request({
            method: "get",
            params,
            url: `middlescreen/api/zhwygkgs/qtgsinfo`,
            params
        });
    },

    //报事报修详情 
    bsbxinfo: function (params) {
        return request({
            method: "get",
            params,
            url: `middlescreen/api/zhwybsbx/bsbxinfo`,
            params
        });
    },

}

export default api;